import UnsubscribeLandingPage from './unsubscribe-landing-page';

export default UnsubscribeLandingPage;
